import React, { useState } from 'react';
import { InfoCircleIcon } from 'tdesign-icons-react';
import { Button } from 'tdesign-react';
import { connect } from 'react-redux';
import Modal from './Modal';

function About({ frontConfig }) {
  const { 'about-hide': aboutHide } = frontConfig;
  const [visible, setVisible] = useState(false);
  return aboutHide ? null : (
    <>
      <Button variant='text' icon={<InfoCircleIcon />} onClick={() => setVisible(true)}>
        关于
      </Button>
      <Modal visible={visible} handleClose={() => setVisible(false)} />
    </>
  );
}

export default connect((state) => ({
  frontConfig: state.platform.frontConfig,
}))(About);
